import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Mail, CheckCircle } from "lucide-react";
import AuthShell from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";

export default function AwaitingApprovalPage() {
  const location = useLocation();
  const { user, logout } = useAuth();
  const email = location?.state?.email || user?.email;
  const name = location?.state?.name || user?.full_name;

  return (
    <AuthShell title="Registration received." subtitle="Awaiting approval">
      <div className="space-y-6">
        <div className="border border-border p-5 bg-accent/60">
          <div className="flex items-center gap-3">
            <CheckCircle className="h-5 w-5 text-primary" aria-hidden="true" />
            <div className="font-display font-bold text-[15px]">
              {name ? `Thanks, ${name}.` : "Thanks for signing up."}
            </div>
          </div>
          <p className="text-[13.5px] text-muted-foreground mt-3 leading-relaxed">
            Your account <strong className="text-foreground font-semibold">{email}</strong> is
            currently awaiting admin approval. You'll receive a confirmation email as soon as your
            account is active and your training modules are assigned.
          </p>
        </div>
        <div className="flex items-start gap-3 text-[13px] text-muted-foreground">
          <Mail className="h-4 w-4 mt-0.5 shrink-0" aria-hidden="true" />
          <div>A notification email was sent. Please check your inbox (and spam folder).</div>
        </div>
        <div className="flex items-center gap-2 pt-2">
          {user && (
            <button data-testid="awaiting-logout-button" onClick={logout} className="h-11 px-5 border border-border font-semibold text-[13px] hover:bg-accent">
              Sign out
            </button>
          )}
          <Link to="/" className="h-11 px-5 inline-flex items-center bg-primary text-primary-foreground font-semibold text-[13px] hover:bg-[#001d6b]">
            Back to home
          </Link>
        </div>
      </div>
    </AuthShell>
  );
}
